import { headerLogoCenterTitle } from './HeaderLogoStore.js';

export const updateHeaderLogoCenterTitle = (value) => headerLogoCenterTitle.update((oldValue) => value);
